import { NavLink } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';
import { PageHeader } from '@/shared/components/page-header';
import { AccountTabTransition } from './account-tab-transition';

const TABS = [
  { path: '/conta', label: 'Perfil', end: true },
  { path: '/conta/senha', label: 'Senha', end: false },
  { path: '/conta/qr-code', label: 'QR-Code', end: false },
] as const;

export function AccountLayout() {
  return (
    <>
      <PageHeader title="Minha conta" description="Perfil, segurança e QR-Code." />
      <div className="mb-6 glass-thin inline-flex rounded-xl p-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'relative rounded-lg px-3.5 py-2.5 text-sm font-medium transition-colors',
                isActive ? 'text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
              )
            }
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute inset-0 rounded-lg bg-primary shadow-soft" />}
                <span className="relative">{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
      <AccountTabTransition />
    </>
  );
}
